const TYPES_TICKETMASTER = {
    APPROVED: 'APPROVED',
    PENDING: 'PENDING',
    REVERSED: 'REVERSED',
    N_A: 'N/A',
};

const TYPES = {
    ORDERED: 'ORDERED',
    PROCESSED: 'PROCESSED',
    REFUNDED: 'REFUNDED',
    CANCELLED: 'CANCELLED',
    DELIVERED: 'DELIVERED',
    PAID: 'PAID',
    REPLACED:'REPLACED'
};

const ORDER_DETAIL = {
    REFUNDED: 'Refunded'
}

const ret = {
    TYPES: TYPES,
    ORDER_DETAIL: ORDER_DETAIL,
    PARTNERS: {
        TICKETMASTER: {
            TYPES: TYPES_TICKETMASTER,
            ITEMS: [
                {
                    id: 1,
                    value: TYPES_TICKETMASTER.APPROVED,
                    i18nKey: '_common:entities.orderTMStatus.items.approved',
                },
                {
                    id: 2,
                    value: TYPES_TICKETMASTER.PENDING,
                    i18nKey: '_common:entities.orderTMStatus.items.pending',
                },
                {
                    id: 3,
                    value: TYPES_TICKETMASTER.REVERSED,
                    i18nKey: '_common:entities.orderTMStatus.items.reversed',
                },
                {
                    id: 4,
                    value: TYPES_TICKETMASTER.N_A,
                    i18nKey: '_common:entities.orderTMStatus.items.n_a',
                },
            ],
        },
    },
};

export default ret;
